export const categoryTypes = {
    'en': [
        { title: 'Any', value: 'all' },
        { title: 'Condominium Projects', value: 'condo' },
        { title: 'House Projects', value: 'house' }
    ],
    'th': [
        { title: 'ทั้งหมด', value: 'all' },
        { title: 'โครงการคอนโดมิเนียม', value: 'condo' },
        { title: 'โครงการบ้าน', value: 'house' }
    ],
    'cn': [
        { title: '不限', value: 'all' },
        { title: '公寓项目', value: 'condo' },
        { title: '别墅项目', value: 'house' }
    ],
    'ru': [
        { title: 'Все типы', value: 'all' },
        { title: 'Кондоминиумы', value: 'condo' },
        { title: 'Виллы и дома', value: 'house' }
    ],
    'fr': [
        { title: 'Tous', value: 'all' },
        { title: 'Projets de condos', value: 'condo' },
        { title: 'Projets de maisons', value: 'house' }
    ],
    'de': [
        { title: 'Alle', value: 'all' },
        { title: 'Eigentumswohnungen', value: 'condo' },
        { title: 'Haus-Projekte', value: 'house' }
    ],
    'it': [
        { title: 'Tutti', value: 'all' },
        { title: 'Progetti di condomini', value: 'condo' },
        { title: 'Progetti di case', value: 'house' }
    ],
    'ja': [
        { title: 'すべて', value: 'all' },
        { title: 'コンドミニアム計画', value: 'condo' },
        { title: '戸建て住宅計画', value: 'house' }
    ],
    'ko': [
        { title: '전체', value: 'all' },
        { title: '콘도미니엄 프로젝트', value: 'condo' },
        { title: '주택 프로젝트', value: 'house' }
    ],
    'es': [
        { title: 'Cualquiera', value: 'all' },
        { title: 'Proyectos de condominios', value: 'condo' },
        { title: 'Proyectos de casas', value: 'house' }
    ],
    'tr': [
        { title: 'Tümü', value: 'all' },
        { title: 'Condo Projeleri', value: 'condo' },
        { title: 'Konut Projeleri', value: 'house' }
    ],
    'he': [
        { title: 'הכל', value: 'all' },
        { title: 'פרויקטים של דירות', value: 'condo' },
        { title: 'פרויקטים של בתים', value: 'house' }
    ],
    'ar': [
        { title: 'الكل', value: 'all' },
        { title: 'مشاريع كوندومينيوم', value: 'condo' },
        { title: 'مشاريع سكنية', value: 'house' }
    ]
};